<script setup>
import { globalTranslate } from '../locale/app.i18n';

</script>

<template>
  <p :class="$style.information">
    <b>
      {{ globalTranslate('assignment.rbsInstruction1') }}
      <a
        :class="$style.rbsLink"
        target="_blank"
        href="https://abcbiz.abc.ca.gov/registration"
      >{{ globalTranslate('assignment.createRbsAccount') }}</a>
      {{ globalTranslate('assignment.rbsInstruction2') }}
    </b>
    <br>
    {{ globalTranslate('assignment.rbsServerIdFee') }}
  </p>
</template>

<style lang="scss" module>
.information {
  font-size: var(--font-size-lg);
}

.rbsLink {
  color: var(--primary-color);
  text-decoration: underline;
}

.rbsLink:hover {
  color: var(--primary-color);
}

</style>
